import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
var rootStyles = process.env.NODE_ENV === "production" ? {
  name: "1el6ue1",
  styles: "font-size:12px;line-height:14px;margin:0.5rem 0;padding:0"
} : {
  name: "1cuo2x3-rootStyles",
  styles: "font-size:12px;line-height:14px;margin:0.5rem 0;padding:0;label:rootStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmREZXNjcmlwdGlvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUJtQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9DYXJkRGVzY3JpcHRpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxudHlwZSBPd25Qcm9wcyA9IHtcbiAgY2hpbGRyZW4/OiBSZWFjdC5SZWFjdE5vZGU7XG4gIGNvbnRlbnQ/OiBSZWFjdC5SZWFjdE5vZGU7XG59O1xuXG50eXBlIFVuaGFuZGxlZFByb3BzID0gT21pdDxcbiAgUmVhY3QuSFRNTEF0dHJpYnV0ZXM8SFRNTFBhcmFncmFwaEVsZW1lbnQ+LFxuICBrZXlvZiBPd25Qcm9wc1xuPjtcblxudHlwZSBQcm9wcyA9IE93blByb3BzICYgVW5oYW5kbGVkUHJvcHM7XG5cbmNvbnN0IHJvb3RTdHlsZXMgPSBjc3Moe1xuICBmb250U2l6ZTogJzEycHgnLFxuICBsaW5lSGVpZ2h0OiAnMTRweCcsXG4gIG1hcmdpbjogJzAuNXJlbSAwJyxcbiAgcGFkZGluZzogJzAnLFxufSk7XG5cbmNvbnN0IENhcmREZXNjcmlwdGlvbjogUmVhY3QuRkM8UHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNvbnRlbnQsXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiAoXG4gIDxwIHsuLi51bmhhbmRsZWRQcm9wc30gY3NzPXtyb290U3R5bGVzfT5cbiAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogY29udGVudH1cbiAgPC9wPlxuKTtcblxuQ2FyZERlc2NyaXB0aW9uLmRpc3BsYXlOYW1lID0gJ0NhcmREZXNjcmlwdGlvbic7XG5cbmV4cG9ydCBkZWZhdWx0IENhcmREZXNjcmlwdGlvbjtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var CardDescription = function CardDescription(_ref) {
  var children = _ref.children,
      content = _ref.content,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("p", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : content);
};

CardDescription.displayName = 'CardDescription';
export default CardDescription;